import { useState, useEffect } from "react"

/**
 * Get an up-to-date URL object for the current browser URL
 *
 * @example
 * ```js
 * function Component() {
 *   let currentUrl = useCurrentUrl()
 *
 *   console.log(currentUrl);
 *   // { host: "example.com", pathname: "/path/to/page", searchParams: URLSearchParams, ... }
 * }
 * ```
 */
export default function useCurrentUrl() {
	let [currentUrl, setCurrentUrl] = useState(
		() => new URL(window.location as any),
	)

	useEffect(() => {
		function onChange() {
			setCurrentUrl(new URL(window.location as any))
		}

		window.addEventListener("popstate", onChange)
		window.addEventListener("hashchange", onChange)

		let interval = setInterval(() => {
			if (window.location.href !== currentUrl.href) {
				onChange()
			}
		}, 50)

		return () => {
			window.removeEventListener("popstate", onChange)
			window.removeEventListener("hashchange", onChange)
			clearInterval(interval)
		}
	}, [currentUrl])

	return currentUrl
}
